<template>
    <div>
        <div style="background-color: #fafafa; padding: 1rem;">
            <div v-if="tasks.length > 0">
                <task
                    v-for="(task, index) in tasks"
                    :task="task"
                    @click="showTask(task)"
                    :key="task.id"
                    :show-destroy="!task.id || showDestroy"
                    @destroy="removeTask"
                ></task>
            </div>

            <div v-else class="card text-center">
               <div class="text-center subtle-text" style="padding-top: 1.8rem; padding-bottom: 2rem; color: rgb(153, 153, 153); font-size: 1.4rem;">
                    No jobs
                </div>
            </div>
        </div>

        <!-- Existing Task Modal !-->
        <task-modal 
            ref="taskModal" 
            :allow-vehicle-editing="allowVehicleEditing"
            :default-task-attributes="defaultTaskAttributes"
            :soft-save="!saveTasks"
            :show-new-job-instance="showNewJobInstance"
            :show-warranty-item-options="showWarrantyItemOptions"
            :task-template-context="taskTemplateContext"
            @destroyed="taskRemoved" 
            @updated="taskUpdated"
        ></task-modal>
    </div>
</template>

<script>
    import TaskModal from '../forms/TaskModal'
    import Task from './Task'
    import { TaskTypes } from '../../classes/Api/Task'

    export default {
        props: { 
            instance: {},
            taskTemplateContext: {
                type: String,
            },
            showWarrantyItemOptions: {
                type: Boolean,
                default: false
            },
            defaultTaskAttributes: {
                type: Object,
                default() {
                    return { type: TaskTypes.JOB }
                }
            },
            value: {
                type: Array,
                default() {
                    return [];
                }
            },
            allowTaskAddition: {
                type: Boolean,
                default: true,
            },
            allowVehicleEditing: {
                type: Boolean,
                default: true,
            },
            statuses: {
                type: Array,
                default() {
                    return ['preparation', 'deal']
                }
            },
            saveTasks: {
                type: Boolean,
                default: true,
            },
            showNewJobInstance: {
                type: Boolean,
                default: true,
            },
            showDestroy: {
                type: Boolean,
                default: false
            },
            openOnClick: {
                type: Boolean,
                default: true
            }
        },
        components: { TaskModal, Task },
        data() {
            return {
                savingTask: false,
                originalTasks: [],
                TaskTypes,
            }
        },
        watch: {
            value: {
                handler: function(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.originalTasks = newVal;
                    }
                },
                deep: true,
            }
        },
        created() {
            if (this.value) {
                this.originalTasks = this.value;
            }
        },
        computed: {
            user() {
                return window.marque.ui.user;
            },
            tasks() {
                return this.originalTasks
            }
        },
        methods: {
            showTask(task) {
                if (this.openOnClick && task.id) {
                    this.$refs['taskModal'].open(task);
                }
            },
            taskUpdated(task) {
                this.$emit('updated', task)
            },
            taskRemoved(task) {
                this.$emit('destroyed', task)
            },
            addTask(task = null) {
                this.$refs['taskModal'].open(task);
            },
            removeTask(task) {
                if (confirm('Are you sure you want to remove the task?')) {
                    this.taskRemoved(task);
                }
            }
        },
    }
</script>